/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./referenceIds.vue?vue&type=template&id=1c2f5aae&scoped=true"
import script from "./referenceIds.vue?vue&type=script&lang=js"
export * from "./referenceIds.vue?vue&type=script&lang=js"
import style0 from "./referenceIds.vue?vue&type=style&index=0&id=1c2f5aae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2f5aae",
  null
  
)

export default component.exports